import { Dispatch, ReactNode, SetStateAction } from 'react';
import { filterActiveProductsBy } from '#/products/domain';
import TabsProvider, { Tab, TabsState } from './tabs-context';
import { getFilteredProducts } from './form-view';

interface Props {
  readonly tabsState: TabsState;
  readonly setTabsState: Dispatch<SetStateAction<TabsState>>;
  readonly children: ReactNode;
}

export default function ActiveProductsTabsProvider({
  children,
  setTabsState,
  tabsState,
}: Props) {
  return (
    <TabsProvider
      tabsState={getActiveProductsTabsState(tabsState)}
      setTabsState={(tab) => setTabsState(getActiveProductsTabsState(tab))}
    >
      {children}
    </TabsProvider>
  );
}

function getActiveProductsTabsState(tabsState: TabsState): TabsState {
  return {
    ids: tabsState.ids,
    entities: Object.fromEntries(
      Object.entries(tabsState.entities).map(([id, tab]) => [
        id,
        filterActiveProducts(tab),
      ]),
    ),
  };
}

export function filterActiveProducts(tab: Tab): Tab {
  if (tab.filter == null) {
    return tab;
  }

  return {
    ...tab,
    filter: {
      ...tab.filter,
      // product codes should always be derived from the current filter
      productCodes: getFilteredProducts(tab.filter).map((p) => p.code),
      products: tab.filter.products.filter((product) => {
        return filterActiveProductsBy({ code: product.value }).length > 0;
      }),
      venues: tab.filter.venues.filter((venue) => {
        return filterActiveProductsBy({ venue: venue.value }).length > 0;
      }),
      assets: tab.filter.assets.filter((asset) => {
        return filterActiveProductsBy({ currency: asset.value }).length > 0;
      }),
    },
  };
}
